"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingObjectsManipulator = void 0;
var tslib_1 = require("tslib");
var base_manipulator_1 = require("../base-manipulator");
var anchor_info_manipulator_1 = require("./anchor-info-manipulator");
var image_manipulator_1 = require("./image-manipulator");
var shape_manipulator_1 = require("./shape-manipulator");
var size_manipulator_1 = require("./size-manipulator");
var text_box_properties_manipulator_1 = require("./text-box-properties-manipulator");
var z_order_manipulator_1 = require("./z-order-manipulator");
var FloatingObjectsManipulator = (function (_super) {
    tslib_1.__extends(FloatingObjectsManipulator, _super);
    function FloatingObjectsManipulator(manipulator) {
        var _this = _super.call(this, manipulator) || this;
        _this.anchorInfo = new anchor_info_manipulator_1.AnchorInfoManipulator(manipulator);
        _this.shape = new shape_manipulator_1.ShapeManipulator(manipulator);
        _this.textBoxSize = new size_manipulator_1.AnchorTextBoxSizeManipulator(manipulator);
        _this.pictureSize = new size_manipulator_1.AnchorPictureSizeManipulator(manipulator);
        _this.textBoxProperties = new text_box_properties_manipulator_1.TextBoxPropertiesManipulator(manipulator);
        _this.zOrder = new z_order_manipulator_1.ZOrderManipulator(manipulator);
        _this.image = new image_manipulator_1.ImageManipulator(manipulator);
        return _this;
    }
    return FloatingObjectsManipulator;
}(base_manipulator_1.BaseManipulator));
exports.FloatingObjectsManipulator = FloatingObjectsManipulator;
